import { Badge } from '@/components/ui/badge'
import { Hourglass, ThumbsUp, CircleX } from 'lucide-react'

interface StatusBadgeProps {
  status: 'pending' | 'approved' | 'rejected'
}

export function StatusBadge({ status }: StatusBadgeProps) {
  switch (status) {
    case 'pending':
      return (
        <Badge variant="secondary" className="text-black flex items-center gap-1 hover:bg-[#F7FF91]" style={{ backgroundColor: '#F7FF91' }}>
          <Hourglass className="w-3 h-3" />
          Aguardando Curadoria
        </Badge>
      )
    case 'approved':
      return (
        <Badge className="bg-green-600 text-white flex items-center gap-1 hover:bg-green-600">
          <ThumbsUp className="w-3 h-3" />
          Aprovado
        </Badge>
      )
    case 'rejected':
      return (
        <Badge className="bg-red-600 text-white flex items-center gap-1 hover:bg-red-600">
          <CircleX className="w-3 h-3" />
          Rejeitado
        </Badge>
      )
    default:
      return null
  }
}
